// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".min.js?v=2025-05-14-200430-4ab5b0c-000942";
};